module.exports = __webpack_public_path__ + "public/images/stands-logo-2@2x.e1a234c4481f86ac2491f4798653f4c9.png";